// extracted by mini-css-extract-plugin
export var notificationHost = "_c4-0";